"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLayout = exports.getGridHeight = exports.gridLayoutId = exports.getLayoutCssHeight = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const types_1 = require("./types");
const utils_1 = require("./utils");
const getLayoutCssHeight = (heightInit) => {
    if (heightInit === types_1.GRID_HEIGHT_MODE.auto) {
        // prettier-ignore
        return (0, styled_components_1.css) ` height: 100%; `;
    }
    if (heightInit === types_1.GRID_HEIGHT_MODE.native) {
        // prettier-ignore
        return (0, styled_components_1.css) ` height: auto; `;
    }
    return heightInit;
};
exports.getLayoutCssHeight = getLayoutCssHeight;
const Layout = styled_components_1.default.div `
    position: relative;

    ${({ heightInit }) => (0, exports.getLayoutCssHeight)(heightInit)}
`;
exports.gridLayoutId = 'grid-layout';
const getGridHeight = (availableRowsHeight, heightInit, hasHorizontalScroll, scrollbarWidth) => {
    return hasHorizontalScroll && heightInit === types_1.GRID_HEIGHT_MODE.native
        ? availableRowsHeight + scrollbarWidth
        : availableRowsHeight;
};
exports.getGridHeight = getGridHeight;
class BaseGridLayout extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.resizeObserver = null;
        this.height = 0;
        this.width = 0;
        this.state = {
            mounted: false,
            width: this.width,
            height: this.height
        };
        const rootRef = react_1.default.createRef();
        this.layoutRef = props.innerRef || rootRef;
        this.calcLayout = this.calcLayout.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onResizeUnbind = this.onResizeUnbind.bind(this);
    }
    componentDidMount() {
        this.resizeObserver = new ResizeObserver((entries) => {
            const { width, height } = entries[0].contentRect;
            this.onResize(width, height);
        });
        if (this.layoutRef.current) {
            this.resizeObserver.observe(this.layoutRef.current);
        }
        this.calcLayout();
        // eslint-disable-next-line
        this.setState({
            mounted: true,
            width: this.width,
            height: this.height
        });
    }
    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
    calcLayout() {
        if (this.layoutRef.current) {
            const layoutRect = this.layoutRef.current.getBoundingClientRect();
            this.width = layoutRect.width;
            this.height = layoutRect.height;
        }
    }
    onResize(newWidth, newHeight) {
        if (this.width !== newWidth || this.height !== newHeight) {
            this.width = newWidth;
            this.height = newHeight;
            this.setState({
                width: this.width,
                height: this.height
            }, () => {
                var _a, _b;
                (_b = (_a = this.props).onResize) === null || _b === void 0 ? void 0 : _b.call(_a);
            });
        }
    }
    onResizeUnbind() {
        if (process.env.NODE_ENV === 'test') {
            this.testingCb();
        }
    }
    mountChildren(disableHeight) {
        const { data, heightInit, headerHeight, rowHeight, pagination, hideHeader, selection, columns, scrollbarWidth, defaultColumnWidth, totalRow, subheaderHeight, notification, children } = this.props;
        const layoutWidth = this.state.width;
        const layoutHeight = disableHeight ? heightInit : this.state.height;
        if (layoutWidth === 0 || (layoutHeight === 0 && heightInit !== types_1.GRID_HEIGHT_MODE.native)) {
            if (process.env.NODE_ENV !== 'test' || this.testing) {
                return null;
            }
        }
        const height = layoutHeight || heightInit;
        // TODO: NEED to rewrite, create rows container and take his height
        const availableRowsHeight = (0, utils_1.computeAvailableRowsHeight)({
            data,
            headerHeight,
            rowHeight,
            pagination,
            hideHeader,
            height,
            selection,
            totalRow,
            subheaderHeight,
            notification
        });
        // TODO: NEED to rewrite without availableRowsHeight, use rows container
        const hasVerticalScroll = availableRowsHeight < data.length * rowHeight;
        const columnsWidth = (0, utils_1.computeColumnsWidth)({
            columns,
            layoutWidth,
            hasVerticalScroll,
            scrollbarWidth,
            defaultColumnWidth
        });
        const hasHorizontalScroll = layoutWidth <
            Object.keys(columnsWidth).reduce((res, key) => res + columnsWidth[key], 0);
        return children({
            layoutWidth,
            hasVerticalScroll,
            availableRowsHeight: (0, exports.getGridHeight)(availableRowsHeight, heightInit, hasHorizontalScroll, scrollbarWidth),
            columnsWidth,
            height
        }, this.layoutRef);
    }
    render() {
        const { mounted } = this.state;
        const _a = this.props, { className, heightInit, onSelectionChange, onHeaderSelectionChange, onColumnToggle, onRowClick, onRowDoubleClick, 
        // ref,
        onColumnResize, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "heightInit", "onSelectionChange", "onHeaderSelectionChange", "onColumnToggle", "onRowClick", "onRowDoubleClick", "onColumnResize", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
        const disableHeight = typeof heightInit === 'number';
        return (react_1.default.createElement(Layout, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || exports.gridLayoutId, className: className, heightInit: heightInit, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: this.layoutRef, style: style }), mounted && this.mountChildren(disableHeight)));
    }
}
exports.GridLayout = react_1.default.forwardRef(function GridLayoutBase(props, ref) {
    return (react_1.default.createElement(BaseGridLayout, Object.assign({}, props, { innerRef: ref }), props.children));
});
//# sourceMappingURL=GridLayout.js.map